const WEEKDAYS = [
  { value: 1, label: "Seg" },
  { value: 2, label: "Ter" },
  { value: 3, label: "Qua" },
  { value: 4, label: "Qui" },
  { value: 5, label: "Sex" },
  { value: 6, label: "Sáb" },
  { value: 7, label: "Dom" },
];

// O banco guarda minutos desde a meia-noite; o input nativo fala "HH:MM".
export const minuteToTime = (minute) =>
  `${String(Math.floor((minute ?? 0) / 60)).padStart(2, "0")}:${String((minute ?? 0) % 60).padStart(2, "0")}`;

export const timeToMinute = (value) => {
  const [hour, minute] = String(value || "0:0").split(":").map(Number);
  return (hour || 0) * 60 + (minute || 0);
};

/**
 * Faixa de horário + dias da semana. Usada pelo prazo de resposta e pela janela
 * de uso da IA — se divergirem visualmente, viram duas coisas diferentes na
 * cabeça de quem configura.
 */
const ScheduleWindow = ({
  title,
  description,
  toggleLabel,
  toggleHint,
  enabled,
  startMinute,
  endMinute,
  weekdays,
  onChange,
  children,
}) => (
  <div className="rounded-lg border border-gray-200 p-4">
    <h3 className="font-medium text-gray-900">{title}</h3>
    {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}

    {children}

    <div className="mt-4 flex items-start justify-between gap-4">
      <div>
        <span className="block text-sm font-medium text-gray-700">{toggleLabel}</span>
        {toggleHint && <span className="text-xs text-gray-500">{toggleHint}</span>}
      </div>

      <button
        type="button"
        onClick={() => onChange("enabled", !enabled)}
        className={`relative mt-1 inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${
          enabled ? "bg-green-500" : "bg-gray-300"
        }`}
        role="switch"
        aria-checked={enabled}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
            enabled ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </div>

    {enabled && (
      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <label className="block">
          <span className="mb-1 block text-sm font-medium text-gray-700">Início</span>
          <input
            type="time"
            value={minuteToTime(startMinute)}
            onChange={(event) => onChange("startMinute", timeToMinute(event.target.value))}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-500"
          />
        </label>

        <label className="block">
          <span className="mb-1 block text-sm font-medium text-gray-700">Fim</span>
          <input
            type="time"
            value={minuteToTime(endMinute)}
            onChange={(event) => onChange("endMinute", timeToMinute(event.target.value))}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-500"
          />
        </label>

        <div className="md:col-span-2">
          <span className="mb-2 block text-sm font-medium text-gray-700">Dias</span>
          <div className="flex flex-wrap gap-2">
            {WEEKDAYS.map((day) => {
              const active = weekdays.includes(day.value);
              return (
                <button
                  key={day.value}
                  type="button"
                  onClick={() =>
                    onChange(
                      "weekdays",
                      active
                        ? weekdays.filter((item) => item !== day.value)
                        : [...weekdays, day.value].sort(),
                    )
                  }
                  className={`rounded-lg px-3 py-1.5 text-sm transition-colors ${
                    active
                      ? "bg-green-500 text-white"
                      : "border border-gray-300 text-gray-600 hover:bg-gray-50"
                  }`}
                >
                  {day.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    )}
  </div>
);

export default ScheduleWindow;
